import { default as InfoV2 } from "./InfoV2";
import AccountCircle from "@mui/icons-material/AccountCircle";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import ClearIcon from "@mui/icons-material/Clear";
import Icon from "@mui/material/Icon";
import _ from "lodash";
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../index";

const SPECIALIST_INFO_DEFAULT_STATE = {
  isLoaded: false,
  data: null,
};

const SPECIALIST_INFO_EDIT_DEFAULT_STATE = {
  isEditing: false,
  isUpdating: false,
  data: {
    firstName: "",
    lastName: "",
  },
};

const ProfileModal = ({ open, handleClose }) => {
  const { userId, phoneNumber } = useContext(AuthContext);

  const [specialistInfo, setSpecialistInfo] = useState(
    SPECIALIST_INFO_DEFAULT_STATE,
  );
  const [specialistEdit, setSpecialistEdit] = useState(
    SPECIALIST_INFO_EDIT_DEFAULT_STATE,
  );

  async function loadSpecialist() {
    try {
      const resp = await axios.post(`/api/v1/specialists/get-specialists`, {
        userId,
      });

      setSpecialistInfo((prevState) => ({
        isLoaded: true,
        data: resp?.data,
      }));
    } catch (err) {
      // noop
    }
  }

  useEffect(() => {
    if (specialistInfo.isLoaded || !userId || !open) {
      return;
    }

    loadSpecialist();
  }, [specialistInfo.isLoaded, userId, open]);

  const handleSpecialistChange = async () => {
    setSpecialistEdit((prevState) => ({ ...prevState, isUpdating: true }));

    try {
      const resp = await axios.patch(`/api/v1/specialists`, {
        id: _.head(specialistInfo?.data)?.id,
        firstName: specialistEdit?.data?.firstName,
        lastName: specialistEdit?.data?.lastName,
      });
    } catch (err) {
      throw err;
    }

    setSpecialistEdit((prevState) => ({
      ...prevState,
      isUpdating: false,
      isEditing: false,
    }));
    setSpecialistInfo((prevState) => ({ ...prevState, isLoaded: false }));
  };

  const handleSpecialistEditClick = () => {
    setSpecialistEdit((prevState) => ({
      ...prevState,
      isEditing: true,
      data: {
        firstName: _.head(specialistInfo?.data)?.firstName || "",
        lastName: _.head(specialistInfo?.data)?.lastName || "",
      },
    }));
  };

  const handleSpecialistEditCancel = () => {
    setSpecialistEdit(SPECIALIST_INFO_EDIT_DEFAULT_STATE);
  };

  return (
    <Box>
      <InfoV2
        open={open}
        handleClose={handleClose}
        sxExtra={{
          minWidth: {
            xs: "90%",
            sm: "420px",
          },
          width: {
            xs: "90%",
            sm: "420px",
          },
          minHeight: "480px",
        }}
      >
        {/* profile top part, same as AccountScreenV2 */}
        <Box
          sx={{
            borderRadius: "20px",
            backgroundColor: "rgb(255 255 255)",
            pb: "5px",
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "120px",
            }}
          >
            <AccountCircle
              sx={{ fontSize: "100px", color: "rgb(0 0 0/0.15)" }}
            />
          </Box>
          <Box sx={{ p: 2 }}>
            <Typography
              align={"center"}
              sx={{ fontWeight: "bold", fontSize: "20px", color: "#777" }}
            >
              {`${_.head(specialistInfo?.data)?.firstName ?? "Имя"} ${_.head(specialistInfo?.data)?.lastName ?? "Фамилия"}`}
            </Typography>
          </Box>
          <Box sx={{ flexGrow: 1 }}>
            <Typography
              sx={{ fontSize: "14px", color: "rgb(0 0 0/0.75)", mb: 1 }}
              align={"center"}
            >
              {phoneNumber}
            </Typography>
          </Box>
          <Box sx={{ p: 2 }}>
            <Stack
              direction={"row"}
              sx={{ justifyContent: "center" }}
              spacing={2}
            >
              <Button
                variant={"contained"}
                onClick={() => handleSpecialistEditClick()}
                sx={{ flex: "1 1 auto", maxWidth: "300px" }}
              >
                Редактировать
              </Button>
            </Stack>
          </Box>
        </Box>
      </InfoV2>
      {/* user edit modal, appears above the profile modal */}
      <Modal
        open={open && specialistEdit.isEditing}
        onClose={handleSpecialistEditCancel}
        sx={{ zIndex: 1350 }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.2)",
            },
          },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            padding: "30px",
            borderRadius: "20px",
            display: "flex",
            flexDirection: "column",
            minWidth: {
              xs: "90%",
              sm: "420px",
            },
            width: {
              xs: "90%",
              sm: "420px",
            },
            minHeight: "480px",
            "&:focus": {
              outline: "none",
            },
          }}
        >
          <Icon
            onClick={() => {
              handleSpecialistEditCancel();
            }}
            sx={{
              "&:hover": {
                cursor: "pointer",
                backgroundColor: "#e3e3e3",
                color: "#fff",
              },
              p: "5px",
              backgroundColor: "#eee",
              borderRadius: "50%",
              zIndex: 1,
              position: "absolute",
              top: "10px",
              right: "10px",
            }}
          >
            <ClearIcon />
          </Icon>
          <Box sx={{ pt: 2, flexGrow: 1 }}>
            <Stack>
              <Typography
                align={"left"}
                fontSize={"12px"}
                sx={{ color: "rgb(0 0 0/ 0.7)" }}
              >
                Имя
              </Typography>
              <TextField
                disabled={specialistEdit.isUpdating}
                value={specialistEdit?.data?.firstName}
                sx={{ width: "100%" }}
                onChange={(event) => {
                  setSpecialistEdit((prevState) => ({
                    ...prevState,
                    data: {
                      ...prevState.data,
                      firstName: event.target.value,
                    },
                  }));
                }}
              />
            </Stack>
            <Stack sx={{ pt: 1 }}>
              <Typography
                align={"left"}
                fontSize={"12px"}
                sx={{ color: "rgb(0 0 0/ 0.7)" }}
              >
                Фамилия
              </Typography>
              <TextField
                disabled={specialistEdit.isUpdating}
                value={specialistEdit?.data?.lastName}
                sx={{ width: "100%" }}
                onChange={(event) => {
                  setSpecialistEdit((prevState) => ({
                    ...prevState,
                    data: {
                      ...prevState.data,
                      lastName: event.target.value,
                    },
                  }));
                }}
              />
            </Stack>
          </Box>
          <Box sx={{ p: 2 }}>
            <Stack
              direction={"row"}
              sx={{ justifyContent: "center" }}
              spacing={2}
            >
              <Button
                variant={"outlined"}
                disabled={specialistEdit.isUpdating}
                onClick={() => {
                  handleSpecialistEditCancel();
                }}
                sx={{ flex: "1 1 auto", maxWidth: "300px" }}
              >
                Отмена
              </Button>
              <Button
                variant={"contained"}
                disabled={specialistEdit.isUpdating}
                onClick={() => {
                  handleSpecialistChange();
                }}
                sx={{ flex: "1 1 auto", maxWidth: "300px" }}
              >
                Сохранить
              </Button>
            </Stack>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default ProfileModal;
